export default {
  guide: {
    label: 'ビギナーズガイド',
    tips: 'こちらからビギナーズガイドをご覧いただけます～',
    title: 'Playturboへようこそ！',
    content:
      'これは強力で使いやすい制作プラットフォームです。まずは主要機能をご紹介し、スムーズに使い始められるようサポートします。',
    startButton: '探索を始める',
    nextButton: '次へ',
    preButton: '前へ',
    complete: '完了',
    step1: {
      label: 'プレイアブルツール',
      describe: {
        title: '3つの制作方法を提供しています：',
        content1:
          'プレイアブルテンプレート：スキンチェンジ制作を活用し、テンプレートを基にアセットを差し替え、パラメータを調整して、高品質なプレイアブル広告を素早く書き出します。',
        content2: {
          title: 'コンテンツエディタ：',
          describe1:
            'ゼロから制作：ユーザーは白紙のキャンバスからPPTを作るように自由にプレイアブル素材を作成でき、あらゆるクリエイティブニーズに対応できます。',
          describe2:
            'テンプレートベースの編集：既存のプレイアブルテンプレート上で要素のレイアウトと編集が可能で、柔軟に素材を調整し、個別のカスタマイズを実現します。',
        },
        content3:
          '動画をプレイアブル化：ビデオをインタラクティブビデオに変換し、迅速にインタラクティブ効果を実現',
      },
    },
    step2: {
      label: 'ビデオツール',
      describe: {
        title: '2つの制作方法を提供しています：',
        content1:
          '動画レイアウトテンプレート：動画サイズと多言語対応に特化し、大量生成に最適です。',
        content2:
          '動画エディター：精密な調整と柔軟な編集で、クリエイティブの反復と最適化を実現します。',
      },
    },
    step3: {
      label: '画像ツール',
      describe: {
        title:
          '「AI画像生成」では、商品リンクを入力するだけで、システムが自動的に商品情報と参考サンプルを取得し、大量の画像クリエイティブをワンクリックで生成します。',
      },
    },
    step4: {
      label: 'デモプロジェクトを表示',
      describe: {
        title:
          '各ツールには、すぐに使い始められるようにデモプロジェクトとヘルプセンターのガイドを用意しています。興味のあるデモを見てみましょう！',
      },
    },
  },
}
